/**
 *  Temporary fix before we unite integration and Skymap's errors into same common/error file.
 */
export type ErrorResponseErrorItemCodeXsite =
  | 'xsite:skymap_project_already_connected'
  | 'xsite:xsite_site_already_connected';

export const translations: Record<ErrorResponseErrorItemCodeXsite, string> = {
  'xsite:skymap_project_already_connected':
    'Projektet är redan integrerat med en annan site i Xsite.',
  'xsite:xsite_site_already_connected': 'Siten är redan integrerad med ett annat projekt i SkyMap.',
};
